import { Stack, Typography, Grid, Avatar } from '@mui/material';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { formatInteger } from '../../utils/numberUtils';
import DashboardCard from './DashboardCard';

const Title = styled(Typography)`
    text-align: center;
    margin-top: 10px !important;
    margin-bottom: 40px !important;
`;

const LabelContainer = styled(Typography)`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    text-align: center;
`;

const Icon = styled(RadioButtonCheckedIcon)`
    color: var(--primary);
`;

const Text = styled(Typography)`
    color: var(--grey);
    text-align: left;
    margin-left: 1.5em !important;
    font-weight: 600;
`;

const formatPair = ({ positive, negative }) => `+${formatInteger(positive)} | ${formatInteger(negative)}`;

function DashboardTotals({ totals }) {
    const { t } = useTranslation('dashboard');
    const { totalForecastDeltas, totalBookedBookings, totalAvailableBookings } = totals;

    return (
        <DashboardCard>
            <Title variant="h6">{t('totals.title')}</Title>
            <Grid container spacing={1}>
                <Grid item xs={12} lg={12}>
                    <Avatar
                        sx={{
                            border: '2px solid var(--primary)',
                            bgcolor: 'var(--white)',
                            color: 'var(--primary)',
                            width: '160px',
                            height: '160px',
                            overflowWrap: 'break-word',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                        variant="round"
                    >
                        <Typography variant="h4" align="center">
                            <span className="notranslate">
                                {formatInteger(totalAvailableBookings.positive + totalAvailableBookings.negative)}
                            </span>
                            <Typography variant="body2" align="center">
                                {t('totals.remainingCalls')}
                            </Typography>
                        </Typography>
                    </Avatar>
                </Grid>
                <Grid item xs={12} lg={12}>
                    <Grid container item md={12} justifyContent="center" alignItems="center">
                        <Stack
                            sx={{
                                textAlign: 'right',
                            }}
                            style={{ textAlign: 'center' }}
                        >
                            <div>
                                <LabelContainer>
                                    <Icon />
                                    <span>{t('totals.bookedCalls')}</span>
                                </LabelContainer>
                                <Text variant="body1">
                                    <span className="notranslate">{formatPair(totalBookedBookings)}</span>
                                </Text>
                            </div>
                            <div>
                                <LabelContainer>
                                    <Icon sx={{ opacity: '0.6' }} />
                                    <span>{t('totals.remainingCalls')}</span>
                                </LabelContainer>
                                <Text variant="body1">
                                    <span className="notranslate">{formatPair(totalAvailableBookings)}</span>
                                </Text>
                            </div>
                            <div>
                                <LabelContainer>
                                    <Icon sx={{ color: 'var(--grey)' }} />
                                    <span>{t('totals.availableCalls')}</span>
                                </LabelContainer>
                                <Text variant="body1">
                                    <span className="notranslate">{formatPair(totalForecastDeltas)}</span>
                                </Text>
                            </div>
                        </Stack>
                    </Grid>
                </Grid>
            </Grid>
        </DashboardCard>
    );
}

export default DashboardTotals;
